module.exports = __webpack_public_path__ + "assets/011b35e65c94c930749a64e7aeef87a2.mp4";